import React, { useEffect, useState } from "react";
import { FileDown, UserCheck } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { PaResultBody } from "@/components/pa/PaResultBody";
import { savePdf } from "@/components/pa/PaDossierPanel";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "long", year: "numeric" }) : "");

export const PaSharedResults = ({ caseId }) => {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const r = await api.get(`/v2/owner/cases/${caseId}/pa-results/dossier`, { responseType: "blob" });
      savePdf(r.data, "dossier-property-advisor.pdf");
    } catch { toast.error("Download del dossier non riuscito"); }
    finally { setBusy(false); }
  };
  useEffect(() => {
    if (!caseId) return;
    api.get(`/v2/owner/cases/${caseId}/pa-results`).then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, [caseId]);
  if (!items || items.length === 0) return null;
  return (
    <section className="rounded-2xl bg-white border border-gray-200 p-6 space-y-4" data-testid="owner-pa-results">
      <div className="flex items-center gap-2 text-[#B40101]">
        <UserCheck size={18} />
        <h2 className="text-lg font-bold text-[#0A0A0A]">Elaborazioni del tuo Property Advisor</h2>
      </div>
      <p className="text-xs text-gray-500">Analisi professionali condivise con te dal Property Advisor. Sono distinte dalle tue analisi e non modificano la tua decisione.</p>
      <button onClick={download} disabled={busy} className="vg-btn-secondary flex items-center gap-1 px-3 py-1.5 text-xs" data-testid="owner-pa-dossier-btn">
        <FileDown size={13} /> {busy ? "Generazione…" : "Scarica dossier del Property Advisor"}
      </button>
      {items.map((i) => (
        <div key={i.analysis_id} className="space-y-2" data-testid={`owner-pa-result-${i.analysis_id}`}>
          <div className="flex items-baseline justify-between gap-2 flex-wrap">
            <p className="font-semibold text-[#0A0A0A]">{i.title}</p>
            <span className="text-xs text-gray-600" data-testid={`owner-pa-result-meta-${i.analysis_id}`}>{i.author_label} · versione {i.version} · condivisa il {fmt(i.shared?.at)}</span>
          </div>
          <PaResultBody item={i} />
        </div>
      ))}
    </section>
  );
};
